export default {
  title: 'Security',

  accountSec: 'Account security',
  loginPwd: 'Login password',
  loginPwdDesc: 'Set · change regularly',
  loginPwdAction: 'Edit ›',

  fundPwd: 'Fund password',
  fundPwdUnset: 'Not set · required before VIPPAY payment',
  fundPwdSet: 'Set · required for sensitive actions',
  fundPwdSetup: 'Set ›',
  fundPwdChange: 'Edit ›',

  bindPhone: 'Phone',
  bindPhoneUnset: 'Not linked · for OTP & recovery',
  bindPhoneAction: 'Link ›',
  bindPhoneChange: 'Change ›',

  bindEmail: 'Email',
  bindEmailUnset: 'Not linked · for alerts & recovery',
  bindEmailAction: 'Link ›',
  bindEmailChange: 'Change ›',

  devices: 'Devices',
  deviceCurrent: 'This device · online',
  deviceLocal: 'This device',
  deviceEmpty: 'No signed-in devices',
  deviceLoading: 'Loading…',
  kick: 'Sign out',
  kickOk: 'Device signed out',

  logs: 'Security log',
  logEmpty: 'No security events yet',
  logLoading: 'Loading…',
  logOk: 'OK',
  logBlocked: 'Blocked',
  logUnknown: 'Security event',
  logLocalAction: 'This device',
  logPwdReset: 'Login password reset',
  logReason: {
    bad_password: 'Wrong password',
    bad_code: 'Invalid verification code',
    bad_old_password: 'Wrong current password',
    player_disabled: 'Account disabled',
    login_restricted: 'Sign-in restricted',
    fund_password_mismatch: 'Wrong fund password',
    fund_password_locked: 'Fund password locked',
  },
  logLoginOk: 'Signed in',
  logLoginFail: 'Sign-in failed',
  logNewDevice: 'New device sign-in',
  logWithdrawSubmit: 'Withdraw submitted',
  logPhoneBound: 'Phone linked',
  logPhoneChanged: 'Phone updated',
  logPwdChanged: 'Login password changed',
  logFundSet: 'Fund password set',
  logFundChanged: 'Fund password changed',
  logFundReset: 'Fund password reset',
  logFundVerifyFail: 'Fund password check failed',
  logEmailBound: 'Email linked',
  logEmailChanged: 'Email updated',
  logDeviceKick: 'Remote device signed out',

  changeLoginPwd: 'Change login password',
  currentPwd: 'Current password',
  currentPwdPh: 'Enter current password',
  newPwd: 'New password',
  newPwdPh: '8-64 chars, letters & numbers',
  confirmNewPwd: 'Confirm new password',
  confirmNewPwdPh: 'Re-enter new password',
  confirmChange: 'Confirm',
  pwdHint: 'Other signed-in devices will be signed out after a successful change',
  pwdOk: 'Password changed — other devices signed out',
  errPwdOldEmpty: 'Enter current password',
  errPwdRule: 'New password must be 8-64 chars with letters and numbers',
  errPwdMismatch: 'New passwords do not match',
  errPwdSame: 'New password must differ from the current one',

  setFundPwd: 'Set fund password',
  changeFundPwd: 'Change fund password',
  resetFundPwd: 'Reset fund password',
  currentFundPwd: 'Current fund password',
  newFundPwd: 'New fund password',
  confirmFundPwd: 'Confirm new fund password',
  fundPwdPh: '6 digits',
  fundPwdPhHint: '6 digits — avoid birthday / phone number',
  fundPwdAgain: 'Re-enter',
  forgetFund: 'Forgot fund password?›',
  confirm: 'Confirm',
  fundHint: 'Used for withdrawals and account changes. 5 wrong attempts lock for 2 hours.',
  fundOkSet: 'Fund password set',
  fundOkChange: 'Fund password updated',
  fundOkReset: 'Fund password reset',
  errFundFormat: 'Enter a 6-digit fund password',
  errFundOld: 'Current fund password is incorrect',
  errFundSame: 'New fund password must differ from the current one',
  errFundMismatch: 'Fund passwords do not match',
  viaPhone: '📱 SMS',
  viaEmail: '✉️ Email',
  verifyPhone: 'Verify linked phone',
  verifyEmail: 'Verify linked email',
  otp: 'Code',
  otpPh: '6-digit code',
  sendOtp: 'Send code',
  otpSent: 'Code sent',
  otpCd: '{n}s',
  otpWait: 'Resend in {n}s',
  errOtp: 'Enter a valid code',
  fundNoBind:
    '⚠️ No phone or email linked — self-serve reset unavailable. Link one under Account security, or contact support.',

  changePhone: 'Change phone',
  bindPhoneTitle: 'Link phone',
  stepVerifyPhone: '1 Verify current phone',
  stepBindPhone: '2 Link new phone',
  curPhone: 'Current phone',
  smsOtp: 'SMS code',
  smsOtpCurPh: 'Sent to current phone',
  smsOtpNewPh: 'Sent to new phone',
  next: 'Next',
  newPhone: 'New phone',
  newPhonePh: 'Enter phone number',
  confirmBind: 'Confirm change',
  confirmBindFirst: 'Confirm',
  phoneHint1: 'Verify the current phone before changing. If SMS fails, contact support.',
  phoneHint2: 'OTP and security alerts will go to the new phone.',
  phoneOk: 'Phone updated',
  errPhone: 'Enter a valid phone number',
  errPhoneSame: 'New phone must differ from the current one',

  bindEmailTitle: 'Link email',
  changeEmail: 'Change email',
  stepVerifyEmail: '1 Verify current email',
  stepBindEmail: '2 Link new email',
  curEmail: 'Current email',
  emailOtp: 'Email code',
  emailOtpCurPh: 'Sent to current email',
  emailAddr: 'Email',
  newEmailAddr: 'New email',
  emailPh: "name{'@'}example.com",
  emailHint1: 'Cannot receive mail? Contact support.',
  emailHint2: 'Used for security alerts and recovery. Change anytime.',
  emailOk: 'Email updated',
  errEmail: 'Enter a valid email',
  errEmailSame: 'New email must differ from the current one',
}
